import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-analise-estoque-bi04-lista-grid',
  templateUrl: './analise-estoque-bi04-lista-grid.component.html',
  styleUrls: ['./../../../../../../../assets/styles/styles.grid-analise.css']
})
export class AnaliseEstoqueBi04ListaGridComponent implements OnInit {

  analiseEstoqueTranslate = {
    "Previsão Compras Acessórios": "rmpv.analiseEstoque.PrevisaoComprasAcessorios",
    "Previsão Compras Peças": "rmpv.analiseEstoque.PrevisaoComprasPecas",
    "Previsão Compras Clothing": "rmpv.analiseEstoque.PrevisaoComprasClothing",
    "Realizado Compra Outros": "rmpv.analiseEstoque.realizadoCompraOutros",
    "Realizado Compra Peças": "rmpv.analiseEstoque.realizadoCompraPecas",
    "Realizado Compra Clothing": "rmpv.analiseEstoque.realizadoCompraOClothing",
    "Realizado Compra Acessórios": "rmpv.analiseEstoque.realizadoCompraAcessorios",
    "% Realizado/Previsão Compras": "rmpv.analiseEstoque.%realizadoPrevisaoCompras",
    "Estoque Acessórios": "rmpv.analiseEstoque.estoqueAcessorio",
    "Estoque Outros": "rmpv.analiseEstoque.estoqueOutros",
    "Estoque Clothing": "rmpv.analiseEstoque.estoqueClothing",
    "Estoque Peças": "rmpv.analiseEstoque.estoquePecas",
    "Estoque > 12 meses Clothing": "rmpv.analiseEstoque.estoqueMaior12MesesClothing",
    "Estoque > 12 meses Outros": "rmpv.analiseEstoque.estoqueMaior12MesesOutros",
    "Estoque > 12 meses Peças": "rmpv.analiseEstoque.estoqueMaior12MesesPecas",
    "Estoque > 12 meses Acessório": "rmpv.analiseEstoque.estoqueMaior12MesesAcessorio",
    "% Estoque Baixo Giro": "rmpv.analiseEstoque.estoqueBaixoGiro",
    "Giro de Estoque Peças": "rmpv.analiseEstoque.giroEstoquePecas",
    "Giro de Estoque Acessórios": "rmpv.analiseEstoque.giroEstoqueAcessorios",
    "Giro de Estoque Clothing": "rmpv.analiseEstoque.giroEstoqueClothing",
    "Giro de Estoque PCA Total": "rmpv.analiseEstoque.giroEstoquePCATotal",
    "Quantidade de Peças Atendidas": "rmpv.analiseEstoque.quantidadePecasAtendidas",
    "Quantidade de Peças Solicitadas": "rmpv.analiseEstoque.quantidadePecasSolicitadas",
    "% Disponibilidade Imediata Peças": "rmpv.analiseEstoque.disponibilidadeImediataPecas"
  }

  @Input() dados: any;
  @Input() anoFiltro: any;

  constructor() { }

  ngOnInit(): void {
  }

  getTranslate(value) {
    return this.analiseEstoqueTranslate[value];
  }
}
